// /rapportvakt/exempel/:slug — one delivery, public and indexable. This is
// where cold-outreach recipients land, so under the delivery sits a compact
// pitch and the CTA into the app.

import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import RapportvaktShell, { useRvLang } from '../components/rapportvakt/Shell';
import { Delivery, Glyph } from '../components/rapportvakt/Delivery';
import {
  RAPPORTVAKT_APP_PATH,
  RAPPORTVAKT_DELIVERIES_SORTED,
  RAPPORTVAKT_HELP_PATH,
  RAPPORTVAKT_LANDING_PATH,
  RAPPORTVAKT_PRICE,
  RAPPORTVAKT_SOURCE_COUNT,
  getDeliveryBySlug,
  rapportvaktSamplePath,
} from '../config/rapportvakt';
import { getRapportvaktSampleSeo } from '../config/seoRoutes';

export default function RapportvaktSamplePage() {
  const { slug } = useParams();
  const delivery = getDeliveryBySlug(slug);

  if (!delivery) {
    return <Navigate to={RAPPORTVAKT_LANDING_PATH} replace />;
  }

  const seo = getRapportvaktSampleSeo(delivery);

  return (
    <RapportvaktShell seo={seo}>
      <RapportvaktSampleBody delivery={delivery} />
    </RapportvaktShell>
  );
}

// A child of RapportvaktShell, not RapportvaktSamplePage itself: useRvLang
// reads RvLangContext, which RapportvaktShell only provides to its own
// children — see RapportvaktPage.jsx's RapportvaktApp for the same split.
function RapportvaktSampleBody({ delivery }) {
  const { t, lang } = useRvLang();
  const others = RAPPORTVAKT_DELIVERIES_SORTED.filter((d) => d.slug !== delivery.slug);

  return (
    <main className="rv__inner">
      <div className="rv-sample">
        <p className="rv-sample__kicker">
          <strong>{t.sampleIntroStrong}</strong>
          {t.sampleIntroBody}
        </p>

        <div className="rv-proof">
          <Delivery delivery={delivery} />
        </div>

        <p className="rv-sample__others">
          {t.moreExamples}{' '}
          {others.map((other, index) => (
            <React.Fragment key={other.slug}>
              {index > 0 ? t.andJoiner : ''}
              <Link to={rapportvaktSamplePath(other.slug)}>{other.title}</Link>
            </React.Fragment>
          ))}
          .
        </p>

        <div className="rv-cta">
          <div>
            <h3 className="rv-cta__title">{t.ctaTitle}</h3>
            <p className="rv-cta__sub">
              {t.ctaBody(
                RAPPORTVAKT_SOURCE_COUNT,
                RAPPORTVAKT_PRICE.amount,
                lang === 'en' ? RAPPORTVAKT_PRICE.periodEn : RAPPORTVAKT_PRICE.period
              )}
              <Link to={RAPPORTVAKT_HELP_PATH}>{t.helpPageLink}</Link>
            </p>
          </div>
          <Link className="rv-btn rv-btn--primary" to={`${RAPPORTVAKT_APP_PATH}/`}>
            {t.heroCta}
            <Glyph name="arrow" size={13} />
          </Link>
        </div>
      </div>
    </main>
  );
}
